<template lang="pug">
section
  s-page-title(title='Города')
    template(slot='extension')
      s-sort-button(@click='sorting.opened = true' class='mr-3')
      v-btn(@click='onEdit()' color='primary' depressed) Добавить
  v-card
    s-data-filter(@search='debouncedSearch' :initial='dataFilter.search')
    v-data-table(
      :loading='isLoading'
      :headers='headers'
      :items='list'
      :total-items='total'
      hide-actions
    )
      template(slot='items' slot-scope='props')
        tr(class='with-pointer' @click='onEdit(props.item)')
          td {{ props.item.id }}
          td {{ props.item.sort_number }}
          td {{ props.item.name }}
          td(class='text-xs-right wrapless crud-tools')
            v-btn(icon @click.stop='onDelete(props.item)')
              v-icon(small) delete_outline
            s-publish-status-toggle(
              :value='props.item'
              @success='fetch'
              resource='development/cities'
            )
  s-sorting-list(v-model='sorting' @sort-success='fetch')
</template>

<script>
import { debounce } from 'lodash'
import { mapActions, mapGetters, mapState, mapMutations } from 'vuex'

export default {
  data: () => ({
    headers: [
      {
        text: '#ID',
        align: 'left',
        value: 'id',
        width: '0%',
        sortable: false
      },
      {
        text: 'Сорт',
        align: 'left',
        value: 'sort_number',
        width: '0%',
        sortable: true
      },
      {
        text: 'Имя',
        align: 'left',
        sortable: true,
        value: 'name',
        width: '90%',
      },
      {
        text: '',
        align: 'left',
        width: '0%',
        sortable: false
      }
    ],
    sorting: {
      opened: false,
      resource: 'development/cities',
      itemValue: 'id',
      itemText: 'name'
    }
  }),

  created() {
    this.fetch()
  },

  methods: {
    updatePagination(pagination) {
      this.setDataFilter({
        ...pagination,  
        rowsPerPage: -1
      })
      this.fetch()
    },

    onEdit({ id } = {}) {
      this.$router.push({
        name: 'Development.Cities.Edit',
        params: { id }
      })
    },

    fetch() {
      this.fetchList({
        config: {
          params: this.dataFilter
        }
      })
    },

    async onDelete({ id }) {
      if (await this.$confirm('Вы уверены?')) {
        try {
          await this.destroy({ id })
          this.fetch()
        } catch (e) {
          this.$root.showSnack('Ошибка удаления')
        }
      }
    },

    debouncedSearch: debounce(function(search) {
      this.setDataFilter({ search, page: 1 })
      this.fetch()
    }, 250),

    ...mapActions('development/cities', ['fetchList', 'destroy']),
    ...mapMutations('development/cities', ['setDataFilter'])
  },

  computed: {
    ...mapState('development/cities', ['total', 'dataFilter']),
    ...mapGetters('development/cities', ['list', 'isLoading']),
  }
}
</script>
